import {
  StoreLocationActionType,
  StoreLocationAction,
} from './../store-location/+state/store-location.actions';
import {
  ClientStore,
  StoreStatistics,
  User,
  StoreZoneStatus,
  StoreZone,
  Customer,
  StoreOrderItemsStatistics,
  CustomerDetail,
  CustomerOrderSummary,
  CustomerBasic,
  CustomerReservationStatistics,
  CustomerLoyaltyProfile,
  CustomerOrderItem,
  CustomerOrderItems,
  CustomerRecentOrders,
  CustomerLoyaltyTrasactions,
  CustomerReservation,
  CustomerLoyaltyProfileUpdate,
  OrderItem,
  CustomerLoyaltyTrasaction,
  CustomerOrder,
  CustomerEventBookingsStatistics,
  LoyaltyStatistics,
  Product,
  ProductListResponse,
} from '../stores';
import { StoresAction, StoresActionType } from './stores.actions';
import { combineReducers } from '@ngrx/store';
import { Paging, PageableResults } from 'src/app/api/types/Pageable';
import {
  StorePaymentMethodsActionType,
  StorePaymentMethodsAction,
} from '../store-payment-methods/+state/payment.actions';
import { ApiRequestStatus } from 'src/app/api/types/Status';
import { SocialLinkErrors } from 'src/app/stores/types/SocialLinks';
import { NotificationSubscriptions } from 'src/app/shared/notifications';
import { emptyPage, Page } from 'src/app/api/types/Page';
import {
  BookingTierDTO,
  SubEventDTO,
} from '../store-events-bookings/store-events-bookings';
import { StoreActionType } from '../store-standalone-payment/+state/stores.actions';
import { StoreIntegrationsMethodsAction } from '../store-integrations/+state/integration.actions';

export enum SortMode {
  NewestOrderSent = 'admin.store.order.newestOrderSent',
  OldestOrderSent = 'admin.store.order.oldestOrderSent',
  NewestOrderWish = 'admin.store.order.newestOrderWish',
  OldestOrderWish = 'admin.store.order.oldestOrderWish',
  NewestOrderExpected = 'admin.store.order.newestOrderExpected',
  OldestOrderExpected = 'admin.store.order.oldestOrderExpected',
  NewestOrderEffective = 'admin.store.order.newestOrderEffective',
  OldestOrderEffective = 'admin.store.order.oldestOrderEffective',
}

export enum DateTimeRangeMode {
  NoFilter = 'admin.store.order.noFilter',
  OrderSent = 'admin.store.order.orderSent',
  OrderWish = 'admin.store.order.orderWish',
  OrderExpected = 'admin.store.order.orderExpected',
  OrderEffective = 'admin.store.order.orderEffective',
}

export enum DateTimeRangeType {
  NoFilter = 'admin.store.order.noFilter',
  Yesterday = 'admin.store.order.yesterday',
  Today = 'admin.store.order.today',
  LastHour = 'admin.store.order.lastHour',
  Now = 'admin.store.order.now',
  NextHour = 'admin.store.order.nextHour',
  Tomorrow = 'admin.store.order.tomorrow',
  Custom = 'admin.store.order.custom',
}

export enum OrderingSetting {
  HIDDEN = 'HIDDEN',
  OPTIONAL = 'OPTIONAL',
  MANDATORY = 'MANDATORY',
}

export enum OrderScopeFilter {
  NO_FILTER = '',
  CUSTOMER = 'CUSTOMER',
  FULFILLMENT = 'FULFILLMENT',
  ALL = 'ALL',
}

export enum enableStandalonePaymentSetting {
  DISABLED = 'DISABLED',
  ENABLE_OPEN_TAP = 'ENABLE_OPEN_TAP',
}
export enum resrvationAllowCustomerSetting {
  DISABLED = 'DISABLED',
  ENABLE = 'ENABLED',
}

export enum standalonePaymentSourceSetting {
  GONNAORDER = 'GONNAORDER',
  POWERSOFT = 'POWERSOFT',
  TISSL = 'TISSL',
}

export interface TabSortFilterParams {
  labelId: SortMode;
  sortQuery: string;
  isServe: boolean;
  isPickup: boolean;
  isAddress: boolean;
  customerName: string;
  orderToken: string;
  locationId: string;
  dateTimeRangeMode: DateTimeRangeMode;
  dateTimeRangeFrom: DateTimeRangeType;
  dateTimeRangeTo: DateTimeRangeType;
  customDateFrom: string;
  customDateTo: string;
  openTap: boolean;
  stationId: number;
  orderScope?: OrderScopeFilter;
  salesPointIds?: number[];
  /**
   * Orders list Store filter: id of the descendant store the list is narrowed to, or null for the
   * whole hierarchy. Per tab, like `salesPointIds`, so the selection survives a tab switch.
   */
  filterStoreId?: number;
}

export const initialTabSortFilterParams: TabSortFilterParams = {
  labelId: SortMode.NewestOrderSent,
  sortQuery: 'submittedAt,desc',
  isServe: false,
  isPickup: false,
  isAddress: false,
  customerName: '',
  orderToken: '',
  locationId: '-1',
  dateTimeRangeMode: DateTimeRangeMode.OrderSent,
  dateTimeRangeFrom: DateTimeRangeType.NoFilter,
  dateTimeRangeTo: DateTimeRangeType.NoFilter,
  customDateFrom: '',
  customDateTo: '',
  openTap: false,
  stationId: null,
  orderScope: OrderScopeFilter.ALL,
  salesPointIds: [],
  filterStoreId: null,
};

export interface TabFilterBtnStatus {
  filterBtnStatus: string;
  filterPinStatus: string;
}

export const initialTabFilterBtnStatus: TabFilterBtnStatus = {
  filterBtnStatus: 'DISABLED',
  filterPinStatus: 'PINNED',
};

export const initialTabPaging: Paging = {
  page: 0,
  size: 20,
};

export interface TabUserExperience {
  tabSortFilterParams: TabSortFilterParams;
  tabFilterBtnStatus: TabFilterBtnStatus;
  tabPaging: Paging;
}

export const initialTabUserExperience: TabUserExperience = {
  tabSortFilterParams: initialTabSortFilterParams,
  tabFilterBtnStatus: initialTabFilterBtnStatus,
  tabPaging: initialTabPaging,
};

export interface StoreUserExperience {
  // Card #9601 — PENDING tab is conditionally rendered (only on stores with
  // REQUIRES_REALTIME_CONFIRMATION = true, or child stores inheriting from
  // such a parent). The slot is in the persisted state regardless so the
  // existing tab-state restore / persist code paths don't need to special-case
  // its absence.
  PENDING: TabUserExperience;
  OPEN: TabUserExperience;
  REJECTED: TabUserExperience;
  CONFIRMED: TabUserExperience;
  READY: TabUserExperience;
  ORDER_TRACKER: TabUserExperience;
  DELIVERY_TRACKER: TabUserExperience;
  COMPLETED: TabUserExperience;
  tab: string;
}

const tabNames = [
  'PENDING',
  'OPEN',
  'REJECTED',
  'CONFIRMED',
  'READY',
  'ORDER_TRACKER',
  'DELIVERY_TRACKER',
  'COMPLETED',
];

export const initialStoreUserExperience: StoreUserExperience = {
  PENDING: initialTabUserExperience,
  OPEN: initialTabUserExperience,
  REJECTED: initialTabUserExperience,
  CONFIRMED: initialTabUserExperience,
  READY: initialTabUserExperience,
  ORDER_TRACKER: initialTabUserExperience,
  DELIVERY_TRACKER: initialTabUserExperience,
  COMPLETED: initialTabUserExperience,
  tab: '',
};

export interface StoresUserExperience {
  [storeId: string]: StoreUserExperience;
}

export interface StoreImages {
  imageUrl: string;
  logoUrl: string;
  backgroundImageUrl: string;
}

export interface StoreStatisticList {
  statistics: StoreStatistics[];
  menuViewingStatistics: StoreStatistics[];
  loyaltyStatistics: LoyaltyStatistics | null;
  loyaltyStatisticsStatus: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  loyaltyStatisticsStore: LoyaltyStatistics | null;
  loyaltyStatisticsPeriod: LoyaltyStatistics | null;
}

export interface ZonesList {
  zones: StoreZone[];
}

export interface ZoneStatus {
  status: StoreZoneStatus;
}

export interface Zone {
  zone: StoreZone;
  zoneStatus: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
}
export interface StoreOrderItemsStatisticsList {
  status: ApiRequestStatus;
  data: StoreOrderItemsStatistics[];
  paging: Paging;
  totalPages: number;
}
export interface StoresList {
  status: ApiRequestStatus;
  data: ClientStore[];
  paging: Paging;
  totalPages: number;
}

export interface RefundsList {
  status: ApiRequestStatus;
  data: any[];
  paging: Paging;
  totalPages: number;
}

export interface ProductsList {
  products: ProductListResponse[];
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  error: any;
}

export interface PaymentTransactionsList {
  status: ApiRequestStatus;
  data: any[];
  paging: Paging;
  totalPages: number;
}

export interface SelectedStoreState {
  store: ClientStore;
  status: ApiRequestStatus;
  notificationsEnabled: boolean;
  notificationsSupported: boolean;
  autoprintEnabled: boolean;
  autoprintSupported: boolean;
}

export interface Stores {
  list: StoresList;
  loadingStoreId: number;
  selectedStore: SelectedStoreState;
  selectedStoreImages: StoreImages;
  statisticsList: StoreStatisticList;
  orderItemsStatisticsList: StoreOrderItemsStatisticsList;
  zonesList: ZonesList;
  zoneState: ZoneStatus;
  zone: Zone;
  storesUserExperience: StoresUserExperience;
  validationStatus: string[];
  mynextLogin: MyNextLoginState;
  hubriseLogin: HubriseLoginState;
  hubriseLogout: HubriseLogoutState;
  notificationSubscriptions: NotificationSubscriptions;
  refunds: RefundsList;
  products: ProductsList;
  paymentTransactions: PaymentTransactionsList;
}

export interface MyNextLoginState {
  apiKey: string;
  myNextId: string;
  myNextEnabled: boolean;
  invalidCredentials: boolean;
}
export interface PowersoftLoginState {
  invalidCredentials: boolean;
}

export class HubriseLoginState {
  accessToken: string;
  locationName: string;
  catalogName: string;
  customerListName: string;
  invalidCredentials: boolean;
}

export class HubriseLogoutState {
  logoutStatus: 'INITIAL' | 'SUCCESS' | 'FAILED';
}

export interface StoresState {
  stores: Stores;
}

export interface AliasAvailabilityStatus {
  status: 'AVAILABLE' | 'READY_TO_CLAIM' | 'SUBSCRIBE_TO_CLAIM' | 'TAKEN';
}

export const selectedStoreInitialState: ClientStore = {
  id: -1,
  name: '',
  companyName: '',
  vatNumber: '',
  description: '',
  coordinates: {
    longitude: null,
    latitude: null,
  },
  aliasName: '',
  address: {
    addressLine1: '',
    addressLine2: '',
    postCode: '',
    region: '',
    city: '',
    country: {
      id: null,
      name: '',
      phoneCode: '',
      europeanCountry: false,
    },
  },
  companyAddress: {
    addressLine1: '',
    addressLine2: '',
    postCode: '',
    region: '',
    city: '',
    country: {
      id: -1,
      name: '',
      code: '',
      phoneCode: '',
      defaultLocale: '',
      europeanCountry: true,
    },
  },
  phoneNumber: '',
  language: {
    id: null,
    name: '',
    locale: '',
  },
  relation: {
    childStores: [],
    parentStore: null,
    siblingStores: [],
    allDescendantStores: [],
  },
  settings: {},
  externalId: '',
  numberOfLocations: 0,
  numberOfOffers: 0,
  numberOfOrders: 0,
  currency: {
    id: null,
    name: '',
    isoCode: '',
    iso4217Code: '',
    symbol: '',
  },
  timeZone: '',
  specialSchedules: [],
  tag: '',
  createdAt: '',
  isIndependent: false,
  activePaymentMethods: [],
};

export const storesInitialState: Stores = {
  list: {
    status: 'INITIAL',
    data: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
  loadingStoreId: -1,
  selectedStore: {
    store: selectedStoreInitialState,
    status: 'INITIAL',
    notificationsEnabled: false,
    notificationsSupported: true,
    autoprintEnabled: false,
    autoprintSupported: true,
  },
  selectedStoreImages: {
    imageUrl: '',
    logoUrl: '',
    backgroundImageUrl: '',
  },
  statisticsList: {
    statistics: [],
    menuViewingStatistics: [],
    loyaltyStatistics: null,
    loyaltyStatisticsStatus: 'INITIAL',
    loyaltyStatisticsStore: null,
    loyaltyStatisticsPeriod: null,
  },
  orderItemsStatisticsList: {
    status: 'INITIAL',
    data: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
  zonesList: {
    zones: [],
  },
  zoneState: { status: null },
  zone: { zone: null, zoneStatus: 'INITIAL' },
  storesUserExperience: {},
  validationStatus: [],
  mynextLogin: {
    apiKey: '',
    myNextId: '',
    myNextEnabled: true,
    invalidCredentials: false,
  },
  hubriseLogin: {
    accessToken: '',
    locationName: '',
    catalogName: '',
    customerListName: '',
    invalidCredentials: false,
  },
  hubriseLogout: {
    logoutStatus: 'INITIAL',
  },
  notificationSubscriptions: {},
  refunds: {
    status: 'INITIAL',
    data: [],
    paging: { page: 0, size: 20 },
    totalPages: 0,
  },
  products: {
    products: [],
    status: 'INITIAL',
    error: null,
  },
  paymentTransactions: {
    status: 'INITIAL',
    data: [],
    paging: { page: 0, size: 20 },
    totalPages: 0,
  },
};

export function notificationSubscriptions(
  state: NotificationSubscriptions = storesInitialState[
    'notificationSubscriptions'
  ],
  action: StoresAction,
): NotificationSubscriptions {
  switch (action.type) {
    case StoresActionType.UpdateNotificationSubscriptions:
      return { ...action.subscriptions };
    default:
      return state;
  }
}

export function storesUserExperience(
  state: StoresUserExperience = storesInitialState.storesUserExperience,
  action: StoresAction,
): StoresUserExperience {
  const newState = { ...state };
  switch (action.type) {
    case StoresActionType.InitializeStoreUserExperience:
      if (state[action.storeId]) {
        for (const tabName of tabNames) {
          if (state[action.storeId][tabName]) {
            // Do nothing as there are already tab's info...
          } else {
            newState[action.storeId][tabName] = JSON.parse(
              JSON.stringify(initialTabUserExperience),
            );
          }
        }
        // Do nothing when there is already store's tab info and set 'OPEN' as default...
        newState[action.storeId].tab = state[action.storeId].tab || 'OPEN';
      } else {
        newState[action.storeId] = JSON.parse(
          JSON.stringify(initialStoreUserExperience),
        );
        if (newState[action.storeId] && newState[action.storeId].tab === '') {
          newState[action.storeId].tab = 'OPEN';
        }
      }
      return { ...newState };
    case StoresActionType.UpdateStoreTabUserExperience:
      newState[action.storeId][action.tabName] = JSON.parse(
        JSON.stringify(action.tabUserExperience),
      );
      newState[action.storeId].tab = action.tabName;
      return { ...newState };
    case StoresActionType.UpdateStoreTab:
      newState[action.storeId].tab = action.newTab;
      return { ...newState };
  }
  return state;
}
export function orderItemsStatisticsList(
  state: StoreOrderItemsStatisticsList = storesInitialState.orderItemsStatisticsList,
  action: StoresAction,
): StoreOrderItemsStatisticsList {
  switch (action.type) {
    case StoresActionType.LoadOrderItemsStatisticsPage:
      return { ...state, status: 'LOADING', paging: action.paging };
    case StoresActionType.LoadOrderItemsStatisticsSuccess:
      return {
        status: 'LOADED',
        data: action.orderItems.data,
        paging: { ...state.paging, page: action.orderItems.pageNumber },
        totalPages: action.orderItems.totalPages,
      };
  }
  return state;
}

export function list(
  state: StoresList = storesInitialState.list,
  action: StoresAction,
): StoresList {
  switch (action.type) {
    case StoresActionType.LoadStores:
    case StoresActionType.SearchStores:
      return { ...state, status: 'LOADING' };
    case StoresActionType.LoadStoresPage:
      return { ...state, status: 'LOADING', paging: action.paging };
    case StoresActionType.LoadStoresSuccess:
    case StoresActionType.SearchStoresSuccess:
      return {
        status: 'LOADED',
        data: action.stores.data,
        paging: { ...state.paging, page: action.stores.pageNumber },
        totalPages: action.stores.totalPages,
      };
    case StoresActionType.LoadStoresFailed:
    case StoresActionType.SearchStoresFailed:
      return { ...storesInitialState.list, status: 'FAILED' };
    default:
      return state;
  }
}

export function selectedStore(
  state: SelectedStoreState = storesInitialState.selectedStore,
  action:
    | StoresAction
    | StorePaymentMethodsAction
    | StoreLocationAction
    | StoreIntegrationsMethodsAction,
): SelectedStoreState {
  switch (action.type) {
    case StoresActionType.InitializeState:
      return { ...storesInitialState.selectedStore };
    case StoresActionType.LoadStore:
      return {
        store: {
          ...selectedStoreInitialState,
          id: action.id,
        },
        status: 'LOADING',
        notificationsEnabled: state.notificationsEnabled,
        notificationsSupported: state.notificationsSupported,
        autoprintEnabled: state.autoprintEnabled,
        autoprintSupported: state.autoprintSupported,
      };
    case StoresActionType.UpdateStore:
      return { ...state, status: 'LOADING' };
    case StoresActionType.LoadStoreSuccess:
    case StoresActionType.UpdateStoreSuccess:
      return {
        store: action.store,
        status: 'LOADED',
        notificationsEnabled: state.notificationsEnabled,
        notificationsSupported: state.notificationsSupported,
        autoprintEnabled: state.autoprintEnabled,
        autoprintSupported: state.autoprintSupported,
      };
    case StoresActionType.LoadStoreFailed:
    case StoresActionType.UpdateStoreFailed:
      return { ...state, status: 'FAILED' };
    case StoreLocationActionType.CreateStoreLocationSuccess:
      return {
        ...state,
        store: {
          ...state.store,
          numberOfLocations:
            state.store.numberOfLocations + action.clientStoreLocations.length,
        },
      };
    case StoresActionType.DeleteStoreSuccess:
      return { ...storesInitialState.selectedStore };
    case StoreLocationActionType.DeleteStoreLocationSuccess: {
      const numberOfLocations = state.store.numberOfLocations - 1;
      const settings = { ...state.store.settings };
      settings.DELIVERY_IN_STORE_LOCATION =
        numberOfLocations > 0 ? settings.DELIVERY_IN_STORE_LOCATION : false;
      return {
        ...state,
        store: { ...state.store, numberOfLocations, settings },
      };
    }
    case StorePaymentMethodsActionType.DisconnectStripeSuccess: {
      const settings = { ...state.store.settings };
      settings.PAYMENT_STRIPE_CREDIT_CARD_ENABLED = false;
      settings.STRIPE_ACCOUNT_ID = '';
      return { ...state, store: { ...state.store, settings } };
    }
    case StorePaymentMethodsActionType.ToggleStripeSuccess:
    case StorePaymentMethodsActionType.ToggleSquareSuccess:
    case StorePaymentMethodsActionType.ConnectPaymentsenseSuccess:
      return { ...state, store: { ...state.store, settings: action.settings } };
    case StorePaymentMethodsActionType.DisconnectPaypalSuccess: {
      const settings = { ...state.store.settings };
      settings.PAYMENT_PAYPAL_ENABLED = false;
      settings.PAYPAL_MERCHANT_ID = '';
      return { ...state, store: { ...state.store, settings } };
    }
    case StorePaymentMethodsActionType.TogglePaypalSuccess:
      return { ...state, store: { ...state.store, settings: action.settings } };
    case StoresActionType.WoltLoginSuccess:
    case StoresActionType.DisconnectWoltSuccess:
    case StoresActionType.PowersoftLoginSuccess:
    case StoresActionType.DisconnectPowersoftSuccess:
    case StoresActionType.UpdateStoreSettingsSuccess:
    case StoresActionType.MynextLoginSuccess: {
      return { ...state, store: action.store, status: 'LOADED' };
    }
    case StoresActionType.UploadStoreVideoSuccess: {
      // The upload endpoint is generic, so the setting the URL belongs to
      // travels on the action; writing a fixed INACTIVITY_VIDEO here would let
      // a brochure upload overwrite the kiosk video URL in the admin state.
      const updatedStore = {
        ...action.store,
        settings: {
          ...action.store.settings,
          [action.storeSetting || 'INACTIVITY_VIDEO']: action.imageUrl,
        },
      };

      return {
        ...state,
        store: updatedStore,
        status: 'LOADED',
      };
    }
    case StoresActionType.RemoveStoreHeaderVideoSuccess: {
      if (!state.store?.settings) {
        return state;
      }
      // The band and the storefront both read settings.HEADER_VIDEO, so drop
      // the key rather than blanking it: absent is what "no header video"
      // means everywhere else, and it saves the admin a reload.
      const { HEADER_VIDEO: removed, ...remainingSettings } =
        state.store.settings;

      return {
        ...state,
        store: { ...state.store, settings: remainingSettings },
        status: 'LOADED',
      };
    }
    case StoresActionType.WoltLoginFailed:
    case StoresActionType.PowersoftLoginFailed:
    case StoresActionType.UpdateStoreSettingsFailed:
    case StoresActionType.UploadStoreVideoFailed:
      return { ...state, status: 'FAILED' };
    case StoresActionType.PartialUpdateStoreSuccess:
      return { ...state, store: action.store };
    case StoresActionType.UpdateStoreVatPercentageSuccess:
      return { ...state, store: action.store };
    case StoresActionType.LoadNotificationSubscriptionStatusSuccess:
      return { ...state, notificationsEnabled: action.subscriptionStatus };
    case StoresActionType.ToggleNotificationSubscriptionStatusSuccess:
      return { ...state, notificationsEnabled: action.newStatus };
    case StoresActionType.ToggleNotificationPermitted:
      if (!action.permissionStatus) {
        return {
          ...state,
          notificationsEnabled: false,
          notificationsSupported: false,
        };
      }
      return { ...state, notificationsSupported: true };
    case StoresActionType.GetStatusOfZoneSuccess:
      return { ...state };
    case StoresActionType.HubriseLogoutSuccess: {
      const settings = { ...state.store.settings };
      settings.HUBRISE_ACCESS_TOKEN = '';
      settings.HUBRISE_LOCATION_NAME = '';
      settings.HUBRISE_CATALOG_NAME = '';
      settings.HUBRISE_CUSTOMER_LIST_NAME = '';
      return { ...state, store: { ...state.store, settings } };
    }
    case StorePaymentMethodsActionType.ConnectJCCSuccess: {
      return { ...state, store: { ...state.store, settings: action.settings } };
    }
    case StorePaymentMethodsActionType.ConnectJCCFailed:
      return { ...state, status: 'FAILED' };
    case StorePaymentMethodsActionType.DisConnectJCCSuccess: {
      const settings = { ...state.store.settings };
      settings.jccEnabled = false;
      settings.JCC_MERCHANT_ID = '';
      return { ...state, store: { ...state.store, settings } };
    }
    case StorePaymentMethodsActionType.DisConnectJCCFailed:
      return { ...state, status: 'FAILED' };
    case StorePaymentMethodsActionType.ConnectTrustPaymentsSuccess: {
      return { ...state, store: { ...state.store, settings: action.settings } };
    }
    case StorePaymentMethodsActionType.ConnectTrustPaymentsFailed:
      return { ...state, status: 'FAILED' };
    case StorePaymentMethodsActionType.DisconnectTrustPaymentsSuccess: {
      const settings = { ...state.store.settings };
      settings.PAYMENT_TRUSTPAYMENTS_CREDIT_CARD_ENABLED = false;
      settings.TRUSTPAYMENTS_SITE_REFERENCE = '';
      settings.TRUSTPAYMENTS_WEBSERVICE_USER = '';
      settings.TRUSTPAYMENTS_WEBSERVICE_PASSWORD = '';
      return { ...state, store: { ...state.store, settings } };
    }
    case StorePaymentMethodsActionType.DisconnectTrustPaymentsFailed:
      return { ...state, status: 'FAILED' };
    case StorePaymentMethodsActionType.ConnectVivaPaymentsSuccess: {
      return { ...state, store: { ...state.store, settings: action.settings } };
    }
    case StorePaymentMethodsActionType.ConnectVivaPaymentsFailed:
      return { ...state, status: 'FAILED' };
    case StorePaymentMethodsActionType.DisconnectVivaPaymentsSuccess: {
      const settings = { ...state.store.settings };
      settings.PAYMENT_VIVA_PAYMENTS_CREDIT_CARD_ENABLED = false;
      settings.VIVA_MERCHANT_ID = '';
      return { ...state, store: { ...state.store, settings } };
    }
    case StorePaymentMethodsActionType.DisconnectVivaPaymentsFailed:
      return { ...state, status: 'FAILED' };
    case StorePaymentMethodsActionType.ConnectPayablSuccess: {
      return { ...state, store: { ...state.store, settings: action.settings } };
    }
    case StorePaymentMethodsActionType.ConnectPayablFailed:
      return { ...state, status: 'FAILED' };
    case StorePaymentMethodsActionType.DisConnectPayablSuccess: {
      const settings = { ...state.store.settings };
      settings.PAYMENT_PAYABL_CREDIT_CARD_ENABLED = false;
      settings.PAYABL_MERCHANT_ID = '';
      settings.PAYABL_MERCHANT_SECRET = '';
      return { ...state, store: { ...state.store, settings } };
    }
    case StorePaymentMethodsActionType.DisConnectPayablFailed:
      return { ...state, status: 'FAILED' };
    case StoresActionType.UpdateStoreRelation:
      return { ...state, status: 'LOADING' };
    case StoresActionType.UpdateStoreRelationSuccess: {
      // True only when the edit left the store under the SAME parent — the Independent toggle.
      // "Link a parent store" and "Change parent" come through here with a different
      // parentStoreRelations.storeId and must not inherit the previous parent's own fields.
      const parentStoreUnchanged =
        !!state.store.relation &&
        !!state.store.relation.parentStore &&
        Number(state.store.relation.parentStore.storeId) ===
          Number(action.parentStoreRelations.storeId);
      return {
        ...state,
        store: {
          ...state.store,
          relation: {
            childStores:
              state.store.relation && state.store.relation.childStores
                ? state.store.relation.childStores
                : [],
            // Spread what is already there and override only the fields the action carries.
            // Rebuilding this object field by field dropped storeTier and emptied settings, so
            // the parent's Organization icon vanished after every relation edit, the Independent
            // toggle included.
            //
            // The spread is keyed on parent IDENTITY, not merely on a parent being present. This
            // branch also handles "Link a parent store" and "Change parent", where the action
            // carries a DIFFERENT parent: storeTier and settings then belong to the parent being
            // replaced, and carrying them over draws the old group's icon and the old parent's
            // settings (the inherit toggles, the realtime-confirmation gate) under the new
            // parent's name until the LoadStore(id) re-read lands — and for good if that GET
            // fails. On a change of parent, keep only what the action states and let LoadStore
            // fill in the rest.
            //
            // `settings` is a key->value map on StoreRelations (`{ [key: string]: any }`) and
            // every reader indexes it (`parentStore.settings?.REQUIRES_REALTIME_CONFIRMATION`,
            // `?.TIME_FORMAT_SELECTION`, `?.EXTERNAL_DOMAIN`), so `{}` is the empty value for
            // that field. The `settings: []` this replaced wrote an array into a map-typed
            // field; no consumer calls an array method on it.
            parentStore: {
              ...(parentStoreUnchanged
                ? state.store.relation.parentStore
                : { settings: {} }),
              isIndependent:
                parentStoreUnchanged &&
                state.store.relation.parentStore.isIndependent
                  ? state.store.relation.parentStore.isIndependent
                  : false,
              storeAlias: action.parentStoreRelations.storeAlias,
              storeId: action.parentStoreRelations.storeId,
              storeName: action.parentStoreRelations.storeName,
            },
            siblingStores:
              state.store.relation && state.store.relation.siblingStores
                ? state.store.relation.siblingStores
                : [],
            allDescendantStores:
              state.store.relation && state.store.relation.allDescendantStores
                ? state.store.relation.allDescendantStores
                : [],
          },
          isIndependent: action.parentStoreRelations.isIndependent,
        },
        status: 'LOADED',
      };
    }
    case StoresActionType.UpdateStoreRelationFailed:
      return { ...state, status: 'FAILED' };
    case StoresActionType.DeleteStoreParent:
      return { ...state, status: 'LOADING' };
    case StoresActionType.DeleteStoreParentSuccess: {
      return {
        ...state,
        store: {
          ...state.store,
          relation: {
            childStores:
              state.store.relation && state.store.relation.childStores
                ? state.store.relation.childStores
                : [],
            parentStore: null,
            siblingStores:
              state.store.relation && state.store.relation.siblingStores
                ? state.store.relation.siblingStores
                : [],
            allDescendantStores:
              state.store.relation && state.store.relation.allDescendantStores
                ? state.store.relation.allDescendantStores
                : [],
          },
        },
        status: 'LOADED',
      };
    }
    case StoresActionType.DeleteStoreParentFailed:
      return { ...state, status: 'FAILED' };
    case StoresActionType.EposNowSyncCatalogSuccess:
      return { ...state, store: action.store, status: 'LOADED' };
    case StoresActionType.EposNowSyncCatalogFailed:
      return { ...state, status: 'FAILED' };
  }
  return state;
}

export function selectedStoreImages(
  state: StoreImages = storesInitialState.selectedStoreImages,
  action: StoresAction,
): StoreImages {
  switch (action.type) {
    case StoresActionType.LoadStoreSuccess:
      return {
        imageUrl: action.store.settings.IMAGE,
        logoUrl: action.store.settings.LOGO,
        backgroundImageUrl: action.store.settings.IMAGE_BACKGROUND,
      };
    case StoresActionType.UploadStoreImageSuccess:
      return action.backgroundImage
        ? { ...state, backgroundImageUrl: action.imageUrl }
        : { ...state, imageUrl: action.imageUrl };
    case StoresActionType.UploadStoreLogoSuccess:
      return { ...state, logoUrl: action.imageUrl };
    case StoresActionType.RemoveStoreImageSuccess:
      return action.backgroundImage
        ? { ...state, backgroundImageUrl: null }
        : { ...state, imageUrl: null };
    case StoresActionType.RemoveStoreLogoSuccess:
      return { ...state, logoUrl: null };
  }

  return state;
}
export function validationStatus(
  state: string[] = storesInitialState.validationStatus,
  action: StoresAction,
): any {
  switch (action.type) {
    case StoresActionType.UpdateStoreSettingsFailed:
      return [...action.error];
    case StoresActionType.ClearStoreValidation:
      return [...action.error].filter(
        (err) => !SocialLinkErrors.ERROR_LIST.includes(err),
      );
    default:
      return state;
  }
}

export interface ValidateAliasAvailable {
  aliasAvailabilityState: AliasAvailabilityState;
}

export interface AliasAvailabilityState {
  status: 'INITIAL' | 'LOADING' | 'LOADED';
  availabilityState: AliasAvailabilityStatus;
}

export const aliasAvailabilityInitialState: AliasAvailabilityState = {
  status: 'INITIAL',
  availabilityState: null,
};

export function aliasAvailabilityState(
  state: AliasAvailabilityState = aliasAvailabilityInitialState,
  action: StoresAction,
): AliasAvailabilityState {
  switch (action.type) {
    case StoresActionType.ValidateAliasAvailability:
      return {
        ...state,
        status: 'LOADING',
      };
    case StoresActionType.ValidateAliasAvailabilitySuccess:
      return {
        status: 'LOADED',
        availabilityState: action.status,
      };
    case StoresActionType.ValidateAliasAvailabilityFailed:
      return { ...state, availabilityState: null };
    case StoresActionType.ValidateAliasAvailabilityReset:
      return { ...state, availabilityState: null };
  }
  return state;
}

export function statisticsList(
  state: StoreStatisticList = storesInitialState.statisticsList,
  action: StoresAction,
): StoreStatisticList {
  switch (action.type) {
    case StoresActionType.LoadStoreStatisticsSuccess:
      return { ...state, statistics: action.statistics };
    case StoresActionType.LoadMenuViewingStatisticsSuccess:
      return { ...state, menuViewingStatistics: action.statistics };
    case StoresActionType.LoadLoyaltyStatistics:
      return { ...state, loyaltyStatisticsStatus: 'LOADING' };
    case StoresActionType.LoadLoyaltyStatisticsSuccess:
      // Store both STORE and PERIOD data separately
      if (action.groupBy === 'STORE' || action.groupBy === 'store') {
        return {
          ...state,
          loyaltyStatisticsStore: action.statistics,
          loyaltyStatistics: action.statistics,
          loyaltyStatisticsStatus: 'LOADED',
        };
      } else if (action.groupBy === 'PERIOD' || action.groupBy === 'period') {
        return {
          ...state,
          loyaltyStatisticsPeriod: action.statistics,
          loyaltyStatistics: action.statistics,
          loyaltyStatisticsStatus: 'LOADED',
        };
      }
      return {
        ...state,
        loyaltyStatistics: action.statistics,
        loyaltyStatisticsStatus: 'LOADED',
      };
    case StoresActionType.LoadLoyaltyStatisticsFailed:
      return {
        ...state,
        loyaltyStatistics: null,
        loyaltyStatisticsStatus: 'FAILED',
      };
    case StoresActionType.ClearLoyaltyStatistics:
      return {
        ...state,
        loyaltyStatistics: null,
        loyaltyStatisticsStore: null,
        loyaltyStatisticsPeriod: null,
        loyaltyStatisticsStatus: 'INITIAL',
      };
  }

  return state;
}

export function zonesList(
  state: ZonesList = storesInitialState.zonesList,
  action: StoresAction,
): ZonesList {
  switch (action.type) {
    case StoresActionType.LoadZonesSuccess:
      return { zones: action.zones };
    case StoresActionType.LoadZonesFailed:
      return { ...storesInitialState.zonesList };
    default:
      return state;
  }
}

export function zoneState(
  state: ZoneStatus = storesInitialState.zoneState,
  action: StoresAction,
): ZoneStatus {
  switch (action.type) {
    case StoresActionType.GetStatusOfZoneSuccess:
      return { status: action.status };
    case StoresActionType.GetStatusOfZoneFailed:
      return { ...storesInitialState.zoneState };
    default:
      return state;
  }
}

export function zone(
  state: Zone = storesInitialState.zone,
  action: StoresAction,
): Zone {
  switch (action.type) {
    case StoresActionType.LoadZone:
      return { ...state, zoneStatus: 'LOADING' };
    case StoresActionType.LoadZoneSuccess:
      return { zone: action.zone, zoneStatus: 'LOADED' };
    case StoresActionType.LoadZoneFailed:
      return { ...storesInitialState.zone };
    default:
      return state;
  }
}

export function loadingStoreId(
  state: number = storesInitialState.loadingStoreId,
  action: StoresAction,
): number {
  switch (action.type) {
    case StoresActionType.LoadStore:
      return action.id;
    case StoresActionType.LoadStoreFailed:
      return -1;
    default:
      return state;
  }
}

export function refunds(
  state: RefundsList = storesInitialState.refunds,
  action: StoresAction,
): RefundsList {
  switch (action.type) {
    case StoresActionType.LoadRefunds:
      return {
        ...state,
        status: 'LOADING',
        paging: action.paging,
      };
    case StoresActionType.LoadRefundsSuccess:
      return {
        status: 'LOADED',
        data: action.refunds.content || [],
        paging: action.paging,
        totalPages: action.refunds.totalPages || 0,
      };
    case StoresActionType.LoadRefundsFailed:
      return {
        ...state,
        status: 'FAILED',
      };
    case StoresActionType.RegisterRefundSuccess:
      // Reset to first page after successful refund creation
      return {
        ...state,
        paging: { page: 0, size: state.paging.size || 20 },
      };
    default:
      return state;
  }
}

export function products(
  state: ProductsList = storesInitialState.products,
  action: StoresAction,
): ProductsList {
  switch (action.type) {
    case StoresActionType.LoadProducts:
      return { ...state, status: 'LOADING', error: null };
    case StoresActionType.LoadProductsSuccess:
      return {
        status: 'LOADED',
        products: action.products,
        error: null,
      };
    case StoresActionType.LoadProductsFailed:
      return {
        status: 'FAILED',
        error: action.error,
        products: state.products,
      };
    case StoresActionType.DeleteProductSuccess:
      // Products will be reloaded from API via LoadProducts action
      return state;
    default:
      return state;
  }
}

export function paymentTransactions(
  state: PaymentTransactionsList = storesInitialState.paymentTransactions,
  action: StoresAction,
): PaymentTransactionsList {
  switch (action.type) {
    case StoresActionType.LoadPaymentTransactions:
      return {
        ...state,
        status: 'LOADING',
        paging: action.paging,
      };
    case StoresActionType.LoadPaymentTransactionsSuccess:
      return {
        status: 'LOADED',
        data: action.response.paymentTransactionOrders || [],
        paging: action.paging,
        totalPages: action.response.totalPages || 0,
      };
    case StoresActionType.LoadPaymentTransactionsFailed:
      return {
        ...state,
        status: 'FAILED',
        data: [],
      };
    default:
      return state;
  }
}

const reducer: (state: Stores, action: StoresAction) => Stores =
  combineReducers({
    list,
    loadingStoreId,
    selectedStore,
    selectedStoreImages,
    statisticsList,
    zonesList,
    zoneState,
    zone,
    orderItemsStatisticsList,
    storesUserExperience,
    validationStatus,
    mynextLogin,
    hubriseLogin,
    hubriseLogout,
    notificationSubscriptions,
    refunds,
    products,
    paymentTransactions,
  });

export function storesReducer(
  state: Stores = storesInitialState,
  action: StoresAction,
): Stores {
  return reducer(state, action);
}

const reducerAliasAvailability: (
  state: ValidateAliasAvailable,
  action: StoresAction,
) => ValidateAliasAvailable = combineReducers({
  aliasAvailabilityState,
});

export function aliasAvailabilityReducer(
  state: ValidateAliasAvailable,
  action: StoresAction,
): ValidateAliasAvailable {
  return reducerAliasAvailability(state, action);
}
// users begin
export interface UsersList {
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  data: User[];
  allUsers: User;
  paging: Paging;
  totalPages: number;
}
export type InviteUserStatus = 'INITIAL' | 'USER_INVITATION_SENT ' | 'FAILED';
export interface InviteUserState {
  status: InviteUserStatus;
}
export interface Users {
  userList: UsersList;
  inviteUser: InviteUserState;
}

export interface UsersState {
  users: Users;
}

export const usersInitialState: Users = {
  userList: {
    status: 'INITIAL',
    data: [],
    allUsers: null,
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
  inviteUser: {
    status: 'INITIAL',
    // errorMessage: ""
  },
};

export function userList(
  state: UsersList = usersInitialState.userList,
  action: StoresAction,
): UsersList {
  switch (action.type) {
    case StoresActionType.LoadUsers:
    case StoresActionType.LoadUsersPage:
      return { ...state, status: 'LOADING', paging: action.paging };
    case StoresActionType.LoadUsersSuccess:
      return {
        status: 'LOADED',
        data: action.users.data,
        allUsers: action.users.allUsers,
        paging: { ...state.paging, page: action.users.pageNumber },
        totalPages: action.users.totalPages,
      };
    case StoresActionType.LoadUsersFailed:
      return { ...usersInitialState.userList, status: 'FAILED' };
    default:
      return state;
  }
}

export function inviteUser(
  state = usersInitialState.inviteUser,
  action: StoresAction,
): InviteUserState {
  switch (action.type) {
    case StoresActionType.InviteUserSuccess:
      return { status: 'USER_INVITATION_SENT ' };
    case StoresActionType.InviteUserFailed:
      return { status: 'FAILED' };
    default:
      return state;
  }
}

const reducerUser: (state: any, action: any) => Users = combineReducers({
  userList,
  selectedStore,
  inviteUser,
});

export function storesUsersReducer(
  state: Users = usersInitialState,
  action: StoresAction,
): Users {
  return reducerUser(state, action);
}

export function mynextLogin(
  state = storesInitialState.mynextLogin,
  action: StoresAction,
): MyNextLoginState {
  switch (action.type) {
    case StoresActionType.MynextLoginSuccess:
      return {
        apiKey: action.store.settings.DELIVERY_PROVIDER_MYNEXT_API_KEY,
        myNextId: action.store.settings.DELIVERY_PROVIDER_MYNEXT_ACCOUNT_ID,
        myNextEnabled: true,
        invalidCredentials: false,
      };
    case StoresActionType.MynextLoginFailed:
      return { ...storesInitialState.mynextLogin, invalidCredentials: true };
    default:
      return state;
  }
}

export function hubriseLogin(
  state = storesInitialState.hubriseLogin,
  action: StoresAction,
): HubriseLoginState {
  switch (action.type) {
    case StoresActionType.HubriseLoginSuccess:
      return {
        accessToken: action.response.settings.HUBRISE_ACCESS_TOKEN,
        locationName: action.response.settings.HUBRISE_LOCATION_NAME,
        catalogName: action.response.settings.HUBRISE_CATALOG_NAME,
        customerListName: action.response.settings.HUBRISE_CUSTOMER_LIST_NAME,
        invalidCredentials: false,
      };
    case StoresActionType.HubriseLogoutSuccess:
      return {
        accessToken: '',
        locationName: '',
        catalogName: '',
        customerListName: '',
        invalidCredentials: false,
      };
    case StoresActionType.HubriseLoginFailed:
      return { ...storesInitialState.hubriseLogin, invalidCredentials: true };
    default:
      return state;
  }
}

export function hubriseLogout(
  state = storesInitialState.hubriseLogout,
  action: StoresAction,
): HubriseLogoutState {
  switch (action.type) {
    case StoresActionType.HubriseLogoutSuccess:
      return { logoutStatus: 'SUCCESS' };
    case StoresActionType.HubriseLogoutFailed:
      return { logoutStatus: 'FAILED' };
    case StoresActionType.ClearHubriseData:
      return { logoutStatus: 'INITIAL' };
    default:
      return state;
  }
}
export interface Customers {
  customersList: CustomersList;
  topOrderCustomers: TopOrderCustomersList;
  topReservationCustomersList: TopReservationCustomersList;
}

export interface CustomersList {
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  data: Customer[];
  paging: Paging;
  totalPages: number;
}
export interface TopOrderCustomersList {
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  data: Customer[];
  paging: Paging;
  totalPages: number;
}
export interface TopReservationCustomersList {
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  data: Customer[];
  paging: Paging;
  totalPages: number;
}

export const customersInitialState: Customers = {
  customersList: {
    status: 'INITIAL',
    data: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
  topOrderCustomers: {
    status: 'INITIAL',
    data: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
  topReservationCustomersList: {
    status: 'INITIAL',
    data: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
};

export interface CustomersState {
  customers: Customers;
}

// tslint:disable-next-line
export function customersList(
  state: CustomersList = customersInitialState['customersList'],
  action: StoresAction,
): CustomersList {
  switch (action.type) {
    case StoresActionType.LoadCustomersPage:
      return { ...state, status: 'LOADING', paging: action.paging };
    case StoresActionType.LoadCustomersSuccess:
      return {
        status: 'LOADED',
        data: action.customers.data,
        paging: { ...state.paging, page: action.customers.pageNumber },
        totalPages: action.customers.totalPages,
      };
    case StoresActionType.LoadUsersFailed:
      return { ...customersInitialState.customersList, status: 'FAILED' };
    default:
      return state;
  }
}
export function topOrderCustomers(
  state: TopOrderCustomersList = customersInitialState['topOrderCustomers'],
  action: StoresAction,
): TopOrderCustomersList {
  switch (action.type) {
    case StoresActionType.TopOrderCustomersPage:
      return { ...state, status: 'LOADING', paging: action.paging };
    case StoresActionType.TopOrderCustomersSuccess:
      return {
        ...state,
        status: 'LOADED',
        data: action.customers.content,
        paging: { ...state.paging, page: action.customers.pageable.pageNumber },
        totalPages: action.customers.totalPages,
      };
    case StoresActionType.TopOrderCustomersFailed:
      return { ...customersInitialState.topOrderCustomers, status: 'FAILED' };
    default:
      return state;
  }
}
export function topReservationCustomersList(
  state: TopReservationCustomersList = customersInitialState[
    'topReservationCustomersList'
  ],
  action: StoresAction,
): TopReservationCustomersList {
  switch (action.type) {
    case StoresActionType.TopReservationCustomersPage:
      return { ...state, status: 'LOADING', paging: action.paging };
    case StoresActionType.TopReservationCustomersSuccess:
      return {
        ...state,
        status: 'LOADED',
        data: action.customers.content,
        paging: { ...state.paging, page: action.customers.pageable.pageNumber },
        totalPages: action.customers.totalPages,
      };
    case StoresActionType.TopReservationCustomersFailed:
      return {
        ...customersInitialState.topReservationCustomersList,
        status: 'FAILED',
      };
    default:
      return state;
  }
}

const reducerCustomers: (state: any, action: any) => Customers =
  combineReducers({
    customersList,
    selectedStore,
    topOrderCustomers,
    topReservationCustomersList,
  });

export function storeCustomersReducer(
  state: Customers = customersInitialState,
  action: StoresAction,
): Customers {
  return reducerCustomers(state, action);
}
export interface CustomerDetailState {
  customer: CustomerDetail;
}
export interface CustomerOrderState {
  customerOrdersPage: Page<CustomerOrder>;
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
}

export interface CustomerLoyaltyTrasactionState {
  customerLoyaltyTrasactionPage: Page<CustomerLoyaltyTrasaction>;
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
}
export interface CustomerOrderItemList {
  status?: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  data: CustomerOrderItem[];
  paging: Paging;
  totalPages: number;
}
export interface CustomerReservationList {
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  content: CustomerReservation[];
  paging: Paging;
  totalPages: number;
}
export interface CustomerRecentOrderList {
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  content: OrderItem[];
  paging: Paging;
  totalPages: number;
}
export interface CustomerLoyaltyTrasactionsList {
  status: 'INITIAL' | 'LOADING' | 'LOADED' | 'FAILED';
  content: CustomerLoyaltyTrasaction[];
  paging: Paging;
  totalPages: number;
}
export interface CustomerDashboardState {
  selecteddDbCustomer: CustomerDetailState;
  selectedDbCustomerId: number;
  selectedDbStoreId: number;
  dBCustomerOrderSummary: CustomerOrderSummary;
  loadedCustomer: CustomerBasic;
  dBCustomerReservationStatistics: CustomerReservationStatistics;
  dBCustomerLoyaltyProfile: CustomerLoyaltyProfile;
  dBCustomerLoyaltyProfileUpdate: CustomerLoyaltyProfileUpdate;
  dBCustomerOrderItems: CustomerOrderItems;
  dBCustomerRecentOrders: CustomerRecentOrderList;
  dBCustomerLoyaltyTrasactions: CustomerLoyaltyTrasactionsList;
  dBCutomerOrderItemList: CustomerOrderItemList;
  dBCutomerReservationList: CustomerReservationList;
  dBCustomerEventBookingsStatistics: CustomerEventBookingsStatistics;
}
const defaultCustomerInfo: CustomerDetail = {
  id: -1,
  firstName: '',
  lastName: '',
  username: '',
  email: '',
  profilePicture: null,
  emailVerified: null,
  phoneVerified: null,
  phoneNumber: '',
  memberCode: '',
  country: {
    id: null,
    name: '',
    code: '',
    phoneCode: '',
    defaultLocale: '',
    defaultTimeZone: '',
    subscriptionPrice: 0,
    subscriptionCurrency: '',
    europeanCountry: false,
  },
  preferredLanguage: {
    id: null,
    name: '',
    locale: '',
    code: '',
    covered_admin_ui: false,
    covered_customer_ui: false,
  },
  googleAccount: {
    appleIdentifier: '',
    email: '',
    firstName: '',
    lastName: '',
    picture: '',
  },
  appleAccount: {
    appleIdentifier: '',
    email: '',
    firstName: '',
    lastName: '',
    picture: '',
  },
  facebookAccount: {
    appleIdentifier: '',
    email: '',
    firstName: '',
    lastName: '',
    picture: '',
  },
  storeRole: '',
  roles: [],
  loginAt: '',
  registeredAt: '',
};
export const customerDashboardInitialState: CustomerDashboardState = {
  selectedDbCustomerId: -1,
  selectedDbStoreId: -1,
  loadedCustomer: {
    customerName: '',
    customerPhone: '',
    customerEmail: '',
    orderCount: 0,
    streetAddress: '',
    city: '',
    zipCode: '',
    customerStatus: '',
    customerBirthday: null,
    customerGender: '',
    customerPreferences: {},
    instagramUsername: undefined,
    externalCustomers: undefined,
  },
  selecteddDbCustomer: {
    customer: defaultCustomerInfo,
  },
  dBCustomerOrderSummary: {
    count: 0,
    firstUpdated: '',
    lastUpdated: '',
  },
  dBCustomerReservationStatistics: {
    count: 0,
    firstUpdated: '',
    lastUpdated: '',
  },
  dBCustomerEventBookingsStatistics: {
    bookingCount: 0,
    firstBookingDate: '',
    lastBookingDate: '',
    ticketCount: 0,
    reservationCount: 0,
    totalSpent: 0,
  },
  dBCustomerLoyaltyProfile: {
    balance: 0,
    voucherValue: 0,
    totalNonDiscountedAmountSpent: 0,
    amountCollected: 0,
    totalCollected: 0,
    totalRedeemed: 0,
    voucherCode: '',
    lastTransaction: '',
    sinceMemebership: '',
    createdAt: '',
    updatedAt: '',
  },
  dBCustomerLoyaltyProfileUpdate: {
    balance: 0,
    voucherValue: 0,
    totalNonDiscountedAmountSpent: 0,
    totalCollected: 0,
    totalRedeemed: 0,
  },
  dBCustomerLoyaltyTrasactions: {
    status: 'INITIAL',
    content: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
  dBCustomerOrderItems: {
    data: [],
  },
  dBCustomerRecentOrders: {
    status: 'INITIAL',
    content: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
  dBCutomerOrderItemList: {
    status: 'INITIAL',
    data: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
  dBCutomerReservationList: {
    status: 'INITIAL',
    content: [],
    paging: { page: 0, size: 10 },
    totalPages: 0,
  },
};
export function dBCutomerOrderItemList(
  state: CustomerOrderItemList = customerDashboardInitialState[
    'dBCutomerOrderItemList'
  ],
  action: StoresAction,
): CustomerOrderItemList {
  switch (action.type) {
    case StoresActionType.LoadCustomerOrderItems:
      return { ...state, status: 'LOADING' };
    case StoresActionType.LoadCustomerOrderItemsSuccess:
      return {
        status: 'LOADED',
        data: action.OrederItems.data,
        paging: { ...state.paging, page: action.OrederItems.pageNumber },
        totalPages: action.OrederItems.totalPages,
      };
    case StoresActionType.LoadCustomerOrderItemsFailed:
      return {
        ...state,
        ...customerDashboardInitialState['dBCutomerOrderItemList'],
        status: 'FAILED',
      };
    default:
      return state;
  }
}
export function selecteddDbCustomer(
  state: CustomerDetailState = customerDashboardInitialState[
    'selecteddDbCustomer'
  ],
  action: StoresAction,
): CustomerDetailState {
  switch (action.type) {
    case StoresActionType.LoadCustomerReset:
      return { customer: { ...defaultCustomerInfo } };
    case StoresActionType.LoadCustomer:
      return {
        customer: {
          ...customerDashboardInitialState.selecteddDbCustomer.customer,
        },
      };
    case StoresActionType.LoadCustomerFailed:
      return {
        customer: {
          ...customerDashboardInitialState.selecteddDbCustomer.customer,
          id: -1,
        },
      };
    case StoresActionType.LoadCustomerSuccess:
      return {
        customer: {
          ...customerDashboardInitialState.selecteddDbCustomer.customer,
          ...action.customer,
        },
      };
    default:
      return state;
  }
}
export function selectedDbCustomerId(
  state: number = customerDashboardInitialState.selectedDbCustomerId,
  action: StoresAction,
): number {
  switch (action.type) {
    case StoresActionType.LoadCustomer:
      return action.id;
    case StoresActionType.LoadCustomerFailed:
      return -1;
    default:
      return state;
  }
}
export function selectedDbStoreId(
  state: number = customerDashboardInitialState.selectedDbStoreId,
  action: StoresAction,
): number {
  switch (action.type) {
    case StoresActionType.LoadCustomer:
      return action.storeId;
    case StoresActionType.LoadCustomerFailed:
      return -1;
    default:
      return state;
  }
}
export function dBCustomerOrderSummary(
  state: CustomerOrderSummary = customerDashboardInitialState[
    'dBCustomerOrderSummary'
  ],
  action: StoresAction,
): CustomerOrderSummary {
  switch (action.type) {
    case StoresActionType.LoadCustomerOrderSummarySuccess:
      return { ...state, ...action.orderSummary };
    case StoresActionType.LoadCustomerOrderSummary:
    case StoresActionType.LoadCustomerOrderSummaryFailed:
      return {
        ...state,
        ...customerDashboardInitialState['dBCustomerOrderSummary'],
      };
    default:
      return state;
  }
}
export function loadedCustomer(
  state: CustomerBasic = customerDashboardInitialState['loadedCustomer'],
  action: StoresAction,
): CustomerBasic {
  switch (action.type) {
    case StoresActionType.LoadCustomerReset:
      return { ...customerDashboardInitialState['loadedCustomer'] };
    case StoresActionType.LoadBasicDetailOfCustomerSuccess:
      return { ...state, ...action.customer };
    case StoresActionType.LoadBasicDetailOfCustomerFailed:
    case StoresActionType.LoadBasicDetailOfCustomer:
      return { ...state, ...customerDashboardInitialState['loadedCustomer'] };
    default:
      return state;
  }
}

export function dBCustomerReservationStatistics(
  state: CustomerReservationStatistics = customerDashboardInitialState[
    'dBCustomerReservationStatistics'
  ],
  action: StoresAction,
): CustomerReservationStatistics {
  switch (action.type) {
    case StoresActionType.LoadCustomerReservationStatisticsSuccess:
      return { ...state, ...action.reservationStatistics };
    case StoresActionType.LoadCustomerReservationStatisticsFailed:
    case StoresActionType.LoadCustomerReservationStatistics:
      return {
        ...state,
        ...customerDashboardInitialState['dBCustomerReservationStatistics'],
      };
    default:
      return state;
  }
}

export function dBCustomerEventBookingsStatistics(
  state: CustomerEventBookingsStatistics = customerDashboardInitialState[
    'dBCustomerEventBookingsStatistics'
  ],
  action: StoresAction,
): CustomerEventBookingsStatistics {
  switch (action.type) {
    case StoresActionType.LoadCustomerEventBookingsStatisticsSuccess:
      return { ...state, ...action.eventBookingStatistics };
    case StoresActionType.LoadCustomerEventBookingsStatisticsFailed:
    case StoresActionType.LoadCustomerEventBookingsStatistics:
      return {
        ...state,
        ...customerDashboardInitialState['dBCustomerEventBookingsStatistics'],
      };
    default:
      return state;
  }
}

export function dBCustomerLoyaltyProfile(
  state: CustomerLoyaltyProfile = customerDashboardInitialState[
    'dBCustomerLoyaltyProfile'
  ],
  action: StoresAction,
): CustomerLoyaltyProfile {
  switch (action.type) {
    case StoresActionType.LoadCustomerLoyaltyProfileSuccess:
      return { ...state, ...action.loyaltyProfile };
    case StoresActionType.LoadCustomerLoyaltyProfileFailed:
    case StoresActionType.LoadCustomerLoyaltyProfile:
      return {
        ...state,
        ...customerDashboardInitialState['dBCustomerLoyaltyProfile'],
      };
    default:
      return state;
  }
}
export function dBCustomerLoyaltyProfileUpdate(
  state: CustomerLoyaltyProfile = customerDashboardInitialState.dBCustomerLoyaltyProfile,
  action: StoresAction,
): CustomerLoyaltyProfile {
  switch (action.type) {
    case StoresActionType.LoadCustomerLoyaltyProfileSuccess:
      return { ...state, ...action.loyaltyProfile };
    case StoresActionType.LoadCustomerLoyaltyProfileFailed:
    case StoresActionType.LoadCustomerLoyaltyProfile:
      return {
        ...state,
        ...customerDashboardInitialState.dBCustomerLoyaltyProfile,
      };
    default:
      return state;
  }
}

export function dBCustomerOrderItems(
  state: CustomerOrderItems = customerDashboardInitialState[
    'dBCustomerOrderItems'
  ],
  action: StoresAction,
): CustomerOrderItems {
  switch (action.type) {
    case StoresActionType.LoadCustomerOrderItemsStatisticsSuccess:
      return { ...state, ...action.OrederItems };
    case StoresActionType.LoadCustomerOrderItemsStatisticsFailed:
    case StoresActionType.LoadCustomerOrderItemsStatistics:
      return {
        ...state,
        ...customerDashboardInitialState['dBCustomerOrderItems'],
      };
    default:
      return state;
  }
}
export function dBCustomerRecentOrders(
  state: CustomerRecentOrderList = customerDashboardInitialState[
    'dBCustomerRecentOrders'
  ],
  action: StoresAction,
): CustomerRecentOrderList {
  switch (action.type) {
    case StoresActionType.LoadCustomerRecentOrdersSuccess:
      return {
        status: 'LOADED',
        content: action.OrederItems.content,
        paging: { ...state.paging, page: action.OrederItems.number },
        totalPages: action.OrederItems.totalPages,
      };
    case StoresActionType.LoadCustomerRecentOrdersFailed:
      return {
        ...state,
        ...customerDashboardInitialState['dBCustomerRecentOrders'],
        status: 'FAILED',
      };
    case StoresActionType.LoadCustomerRecentOrders:
      return { ...state, status: 'LOADING' };
    default:
      return state;
  }
}
export function dBCutomerReservationList(
  state: CustomerReservationList = customerDashboardInitialState[
    'dBCutomerReservationList'
  ],
  action: StoresAction,
): CustomerReservationList {
  switch (action.type) {
    case StoresActionType.LoadCustomerReservationListSuccess:
      return {
        status: 'LOADED',
        content: action.ReservationItems.content,
        paging: { ...state.paging, page: action.ReservationItems.number },
        totalPages: action.ReservationItems.totalPages,
      };
    case StoresActionType.LoadCustomerReservationListFailed:
      return {
        ...state,
        ...customerDashboardInitialState['dBCutomerReservationList'],
        status: 'FAILED',
      };
    case StoresActionType.LoadCustomerReservationList:
      return { ...state, status: 'LOADING' };
    default:
      return state;
  }
}
export function dBCustomerLoyaltyTrasactions(
  state: CustomerLoyaltyTrasactionsList = customerDashboardInitialState[
    'dBCustomerLoyaltyTrasactions'
  ],
  action: StoresAction,
): CustomerLoyaltyTrasactionsList {
  switch (action.type) {
    case StoresActionType.LoadCustomerLoyaltyTrasactionsSuccess:
      return {
        status: 'LOADED',
        content: action.OrederItems.content,
        paging: { ...state.paging, page: action.OrederItems.number },
        totalPages: action.OrederItems.totalPages,
      };
    case StoresActionType.LoadCustomerLoyaltyTrasactionsFailed:
      return {
        ...state,
        ...customerDashboardInitialState['dBCustomerLoyaltyTrasactions'],
        status: 'FAILED',
      };
    case StoresActionType.LoadCustomerLoyaltyTrasactions:
      return { ...state, status: 'LOADING' };
    default:
      return state;
  }
}
const reducerCustomerDashboard: (
  state: CustomerDashboardState,
  action: StoresAction,
) => CustomerDashboardState = combineReducers({
  selecteddDbCustomer,
  selectedDbCustomerId,
  selectedDbStoreId,
  dBCustomerOrderSummary,
  loadedCustomer,
  dBCustomerReservationStatistics,
  dBCustomerLoyaltyProfile,
  dBCustomerLoyaltyProfileUpdate,
  dBCustomerOrderItems,
  dBCustomerRecentOrders,
  dBCustomerLoyaltyTrasactions,
  dBCutomerOrderItemList,
  dBCutomerReservationList,
  dBCustomerEventBookingsStatistics,
});

export function dashboardCustomerDetailReducer(
  state: CustomerDashboardState = customerDashboardInitialState,
  action: StoresAction,
): CustomerDashboardState {
  return reducerCustomerDashboard(state, action);
}
export interface CustomEndpoint {
  customEndpoint: CustomEndpointURL;
}
export interface CustomEndpointURL {
  customEndpointURL: string;
  validationEndpointURL: string;
}
export const customEndpointInitialState: CustomEndpoint = {
  customEndpoint: {
    customEndpointURL: '',
    validationEndpointURL: '',
  },
};
export interface CustomEndpointState {
  customEndpoint: CustomEndpoint;
}
// tslint:disable-next-line
export function customEndpoint(
  state: CustomEndpointURL = customEndpointInitialState['customEndpoint'],
  action: StoresAction,
): CustomEndpointURL {
  switch (action.type) {
    case StoresActionType.CustomEndPointValidateSuccess:
      return {
        ...state,
        customEndpointURL: action.endpoint,
        validationEndpointURL: action.validationEndpoint,
      };
    case StoresActionType.CustomEndPointValidateFailed:
      return {
        ...state,
        customEndpointURL: '',
        validationEndpointURL: '',
      };
    default:
      return state;
  }
}
const reducerCustomEndpoint: (state: any, action: any) => CustomEndpoint =
  combineReducers({
    customEndpoint,
  });
export function customEndpointReducer(
  state: CustomEndpoint = customEndpointInitialState,
  action: StoresAction,
): CustomEndpoint {
  return reducerCustomEndpoint(state, action);
}

export interface EventState {
  id?: number;
  title: string;
  description: string;
  startDatetime: string;
  endDatetime: string;
  bookingDeadline: string;
  allowPreSaleDiscountedPrices: boolean;
  minimumAge: string;
  lineup: string;
  status: string;
  externalBookingUrl: string;
  musicStyleList: string[];
  bookingTiers: BookingTierDTO[];
  banner: string;
  reel: string;
  floorplan: string;
  useCustomAddress: boolean;
  customAddress: {
    addressName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    country: string;
    zipCode: string;
    latitude: number;
    longitude: number;
  };
  displayPrice: number | null;
  parentEventId?: number | null;
  parentEventName?: string | null;
  subEvents?: SubEventDTO[];
  eventType?: string;
  scheduleId?: number | null;
}

export const eventsInitialState: EventState = {
  id: null,
  title: '',
  description: '',
  startDatetime: '',
  endDatetime: '',
  bookingDeadline: '',
  allowPreSaleDiscountedPrices: false,
  minimumAge: 'EIGHTEEN_PLUS',
  lineup: '',
  status: 'DRAFT',
  externalBookingUrl: '',
  musicStyleList: [],
  bookingTiers: [],
  banner: '',
  reel: '',
  floorplan: '',
  useCustomAddress: false,
  customAddress: {
    addressName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
    latitude: 0,
    longitude: 0,
  },
  displayPrice: null,
  parentEventId: null,
  parentEventName: null,
  subEvents: [],
  eventType: null,
  scheduleId: null,
};
export function eventsReducer(
  state: EventState = eventsInitialState,
  action: StoresAction,
): EventState {
  switch (action.type) {
    case StoresActionType.GetEventSuccess:
      return {
        ...state,
        ...action.eventDetails,
      };
    case StoresActionType.ResetEventState:
      return {
        ...state,
        ...eventsInitialState,
      };
    case StoresActionType.DeleteBookingTierSuccess:
      let bookingTierDate = state.bookingTiers.filter(
        (tier) => tier.id != action.bookingId,
      );
      return {
        ...state,
        bookingTiers: [...bookingTierDate],
      };
    default:
      return state;
  }
}
